module.exports = __webpack_public_path__ + "static/FontAwesome-b06871f281fee6b241d60582ae9369b9.ttf";